module.exports = __webpack_public_path__ + "static/assets/21425ab0c31fc59abd0df0327120f111.svg";